import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'viewerjs/dist/viewer.css'
import './assets/css/macy.css'
import VueViewer from 'v-viewer'
import underscore from 'vue-underscore'
import AOS from 'aos'
import 'aos/dist/aos.css'
import vueCountryRegionSelect from 'vue-country-region-select'

Vue.use(vueCountryRegionSelect)
Vue.config.productionTip = false
Vue.prototype.$url = process.env.VUE_APP_API_URL || 'https://api.marinasamont.com' //variable global
//Vue.prototype.$lang = navigator.languages[1] // navigator.userLanguage;
Vue.use(VueViewer)
Vue.use(underscore);

// Add the toCurrency function using Vue.prototype (Vue 2 syntax)
Vue.prototype.$toCurrency = (value) => {
  // Convert to number and handle NaN
  let numValue = Number(value)
  if (isNaN(numValue)) {
      numValue = 0
  }
  
  if (typeof numValue !== "number") {
      return '';
  }
  
  var formatter = new Intl.NumberFormat('es-MX', {
      style: "decimal",
      minimumFractionDigits: 2,
  })
  
  return formatter.format(numValue) // Always format, even if 0
}

new Vue({
  router,
  store,
  render: function (h) { return h(App) },
  mounted() {
    AOS.init()
    document.dispatchEvent(new Event('render-ready'))
  },
}).$mount('#app')
